import { createFileRoute } from "@tanstack/react-router";
import { PublicProfile } from "@/components/site/PublicProfile";
import { SITE_URL } from "@/components/site/seo";

export const Route = createFileRoute("/profile/$slug")({
  head: ({ params }) => {
    const t = "Sales profile | CLOSDD";
    const d =
      "A CLOSDD sales profile: sales role, location, experience, industries, voice introduction and sales assessment. Refined for the exact candidate once the profile loads.";
    const canonical = `${SITE_URL}/profile/${params.slug}`;
    return {
      meta: [
        { title: t },
        { name: "description", content: d },
        { property: "og:title", content: t },
        { property: "og:description", content: d },
        { property: "og:type", content: "profile" },
        { property: "og:url", content: canonical },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: PublicProfilePage,
});

function PublicProfilePage() {
  const { slug } = Route.useParams();
  return <PublicProfile slug={slug} />;
}
